var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12284_2239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 3.50016C2.33594 2.85583 2.85827 2.3335 3.5026 2.3335L24.497 2.3335C25.1413 2.3335 25.6637 2.85583 25.6637 3.50016L25.6637 24.5002C25.6637 25.1445 25.1413 25.6668 24.497 25.6668L3.50261 25.6668C2.85827 25.6668 2.33594 25.1445 2.33594 24.5002L2.33594 3.50016Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12284_2239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8161 12.7464L0.741455 0.843617L7.29631 -2.60645L12.8161 12.7464Z",
    fill: "#B4B4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6433 13.9999L21.7807 -5.76079L29.0619 -0.171681L14.6433 13.9999Z",
    fill: "#B4B4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98592 13.5023L-4.25727 10.5395L-1.13698 5.00234L9.98592 13.5023Z",
    fill: "#B4B4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0767 17.5725L28.0702 21.5508L24.5602 26.8495L14.0767 17.5725Z",
    fill: "#B4B4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 16.1074L15.6077 30.3097L9.27735 29.741L12.4546 16.1074Z",
    fill: "#B4B4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6891 12.7461L10.0617 -3.81642L17.4374 -3.1325L13.6891 12.7461Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9134 15.925L29.6365 9.58006L30.1951 16.9663L13.9134 15.925Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2826 15.1861L-5.15113 19.3582L-4.71106 11.9639L11.2826 15.1861Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6165 15.4024L3.63355 28.4224L-0.729361 23.3742L11.6165 15.4024Z",
    fill: "#D2D2D8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenGlass);
export default __webpack_public_path__ + "static/media/broken-glass.3bcfef9442f46aa518663fd3a853ce7a.svg";
export { ForwardRef as ReactComponent };